import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);
const LS_TOKEN = "pb_session_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("loading");

  const fetchMe = useCallback(async () => {
    try {
      const t = localStorage.getItem(LS_TOKEN);
      const headers = t ? { Authorization: `Bearer ${t}` } : {};
      const { data } = await axios.get(`${API}/auth/me`, {
        headers,
        withCredentials: true,
      });
      setUser(data);
      setStatus("authed");
    } catch (_e) {
      setUser(null);
      setStatus("anon");
    }
  }, []);

  const exchangeSessionId = useCallback(async (sessionId) => {
    const { data } = await axios.post(
      `${API}/auth/session`,
      { session_id: sessionId },
      { withCredentials: true }
    );
    if (data.session_token) localStorage.setItem(LS_TOKEN, data.session_token);
    setUser(data.user);
    setStatus("authed");
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      const t = localStorage.getItem(LS_TOKEN);
      const headers = t ? { Authorization: `Bearer ${t}` } : {};
      await axios.post(`${API}/auth/logout`, {}, { headers, withCredentials: true });
    } catch (_e) { /* noop */ }
    localStorage.removeItem(LS_TOKEN);
    setUser(null);
    setStatus("anon");
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const value = { user, status, fetchMe, exchangeSessionId, logout };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  const currentUrl = typeof window !== "undefined" ? window.location.href.split("#")[0].split("?")[0] : "";
  const loginUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(currentUrl)}`;
  return { ...ctx, loginUrl };
}

export function useOptionalAuth() {
  return useContext(AuthContext);
}
